<template>
  <div class="blocked-page" :dir="isHebrew ? 'rtl' : 'ltr'">
    <NavBar />
    <div class="blocked-content">
      <div class="blocked-icon">🔒</div>
      <h2 class="blocked-title">{{ t('blockedAccessTitle') }}</h2>
      <p class="blocked-body">{{ t('blockedAccessBody') }}</p>
      <a v-if="rideKeyInformation.redirect_page" :href="rideKeyInformation.redirect_page" class="btn btn-primary mt-3">
        {{ t('blockedAccessButton') }}
      </a>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import { translationMixin } from '@/mixins/translationMixin';
import { mapGetters } from 'vuex';

export default {
  name: 'BlockedAccess',
  mixins: [translationMixin],
  components: { NavBar },
  computed: {
    ...mapGetters(['rideKeyInformation']),
  },
};
</script>

<style scoped>
.blocked-page {
  min-height: 100vh;
  background: #f8f9fa;
}

.blocked-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 4rem 2rem;
  max-width: 480px;
  margin: 80px auto 0;
}

.blocked-icon {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
}

.blocked-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #212529;
}

.blocked-body {
  color: #6c757d;
  font-size: 1rem;
  line-height: 1.6;
}
</style>
